import React from "react";
import { FatalError } from "./FatalError";

export const PageError = () => (
  <div
    className="align-center flex h-screen w-screen items-center justify-center bg-page-loader"
    role="status"
    data-testid="error"
  >
    <FatalError />
  </div>
);
